import React from 'react';


import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Vision from './Vision';
import TestimonialAbout from './TestimonialAbout';
import GoogleAnalytics from '../components/GoogleAnalytics';



const AboutSection = () => {
  return (
   <div>
<GoogleAnalytics/>

<section
        className="page-title"
        style={{ backgroundImage: 'url(images/hero.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer text-center">
            <h1 className="title">About Us </h1>
          </div>
        </div>
      </section>


 <section className="about-section">
      <div className="auto-container container">
        <div className="row ">
          {/* Content Column */}
          <div className="content-column col-lg-6 col-md-12 col-sm-12 order-lg-2" >
            <div className="inner-column">
              <div className="sec-title">
                <span className="sub-title">Welcome to SHREE Tours & Travels </span>
                <h2>We Provide Trusted Cab Services</h2>
                <div className="text">
                SHREE Tours & Travels is committed to offer exceptional travel experiences that combine adventure, comfort and cultural exploration. Our expert team curates personalized itineraries that highlight the best of each destination, from iconic landmarks to hidden gems. At SHREE Tours & Travels, we prioritize responsible tourism, partnering with local communities and eco-conscious organizations to ensure our travels leave a positive impact. Whether you’re seeking scenic Mountain gateways, peaceful beach escapes or immersive cultural adventures. We craft each journey to create unforgettable memories. Let SHREE Tours & Travels turn your travel dreams into reality with outstanding service, local expertise and a passion for extraordinary journeys.
                </div>
                <div className='text'>
               

                </div>
                
              </div>
              <blockquote className="blockquote-style-two fs-3">
                Founder - Mr. Swapnil Jagtap
              </blockquote>
              <div className="bottom-box">
               
                <div className="features-outer">
               
                  <Link to ='/booking' className="theme-btn btn-style-one">
                    <span className="btn-title">Book Your Cab</span>
                  </Link>
                </div>

               
              </div>
            </div>
          </div>

          {/* Image Column */}
          <div className="image-column col-lg-6 col-md-12 col-sm-12">
            <div className="inner-column">
              <figure className="image reveal">
                <img src="/images/about-car.jpg" alt="Image 1" />
              </figure>
              <figure className="image-2" data-aos="fade-up">
               
              </figure>
              <figure className="image-3 reveal">
             
              </figure>
            </div>

          </div>
        </div>
      </div>
    </section>
    <Vision/>
    <TestimonialAbout/>

       </div>
  );
};

export default AboutSection;
